
import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import Spinner from "../spinner/Spinner";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { handleError } from "../../components/utils/AuthenticationCheck";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import AxiosApiCall from "../../api/AxiosApiCall";

const AssignCommission = () => {
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [commissions, setCommissions] = useState([]);
    const [commission_category_id, setCommissionsCategoryId] = useState("");
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    // Get the order details from the location state
    const data = location.state?.data;

    useEffect(() => {
        if (data) {
            // console.log("na be customer info", data);
            setCustomerId(data.id || "");
            setFirstname(data.firstname || "");
            setLastname(data.lastname || "");
            setCustomerName(`${data.firstname || ""} ${data.lastname || ""}`);
            // Set loading to false after data is set
            setLoading(false);
        }
    }, [data]);



    useEffect(() => {
        const fetchAllCommissions = async () => {
            setLoading(true);
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                const token = authData?.token;
                // console.log("Auth Data:", authData);
                if (!token) {
                    throw new Error("No access token found.");
                }

                const response = await axios.get(ApiServices.getAllPhysicalProductCom, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                });

                const { success, message, data } = response.data;
                if (success) {
                    setCommissions(data);
                } else {
                    handleError({ response: { status: 400, data: { message } } }, navigate);
                }
            } catch (error) {
                handleError(error, navigate);
            } finally {
                setLoading(false);
            }
        };

        fetchAllCommissions();
    }, []);

    // Validation function
    const validateForm = () => {
        if (!commission_category_id) {
            toast.error("Please select a commission.");
            return false;
        }
        return true;
    };


    //axios api encryption call
    const axios = AxiosApiCall();

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        const formData = { user_id: customerId, commission_category_id: commission_category_id };

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) {
                throw new Error("No access token found.");
            }

            const response = await axios.post(
                ApiServices.assignToUserPhysicalProductCom,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { success, message } = response.data;
            if (success === true) {
                toast.success(message, { toastId: "commison-assign-successfully" });
                navigate("/admin/customer");
            } else {
                handleError({ response: { success, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    return (
        <MainLayouts>
            <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Customer
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Commission
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">Assign</p>
                            </li>
                        </ol>
                    </nav>
                </section>

                {/* {loading ? (
                    <Spinner loading={loading} />
                ) : ( */}
                <form onSubmit={handleSubmit}>
                    <div className="d-flex">
                        <div className="w-full mb-3">
                            <label
                                htmlFor="user_name"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                                Customer Name
                            </label>
                            <input
                                type="text"
                                id="user_name"
                                value={customerName}
                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                readOnly
                            />
                        </div>

                        <div className="w-full">
                            <label
                                htmlFor="status"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                                Commissions
                            </label>

                            <select
                                id="commission"
                                value={commission_category_id}
                                onChange={(e) => setCommissionsCategoryId(e.target.value)}
                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                            >
                                <option value="" disabled>
                                    Select Commission
                                </option>
                                {commissions.length > 0 ? (
                                    commissions.map((commission, index) => (
                                        <option key={index} value={commission.id}>
                                            {commission.name}
                                        </option>
                                    ))
                                ) : (
                                    <option value="" disabled>
                                        No commissions available
                                    </option>
                                )}
                            </select>

                        </div>
                    </div>
                    <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                        <Link
                            to="/admin/customer"
                            className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
                        >
                            <List className="mr-2" />
                            Back To List
                        </Link>
                        <button
                            type="submit"
                            className={`text-white bg-darkGreen3 text-dGrey3 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"}`}
                            disabled={loading}
                        >
                            {loading ? "Assigning commission..." : "Assign Commission"}
                        </button>
                    </div>
                </form>
                {/* )} */}
            </div>
        </MainLayouts>
    );
};

export default AssignCommission;


